import { ChevronRight, Heart, Radio, UserRound } from 'lucide-react'
import type { CatalogOption } from './types'
import type { LaunchShow } from './launchShows'

type LaunchCastHubProps = {
  shows: LaunchShow[]
  onOpenEntity: (item: CatalogOption) => void
  onOpenRoom: (show: LaunchShow) => void
}

function initials(label: string) {
  return label.split(/\s*&\s*|\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase()
}

export default function LaunchCastHub({ shows, onOpenEntity, onOpenRoom }: LaunchCastHubProps) {
  return (
    <section className="launch-cast" aria-label="Current season cast hubs">
      <header className="launch-cast__header">
        <div><span>NOW IN THE ENCYCLOPEDIA</span><h2>Meet the Newest Cast</h2></div>
        <small>Officially announced casts</small>
      </header>
      <div className="launch-cast__shows">
        {shows.map((show) => (
          <article className={`launch-show launch-show--${show.accent}`} key={show.id}>
            <header>
              <div><span>{show.nightLabel.toUpperCase()}</span><h3>{show.title}</h3><small>Season {show.season} · {show.cast.length} {show.id === 'other-way' ? 'couples' : 'singles'}</small></div>
              <button type="button" onClick={() => onOpenRoom(show)}><Radio size={14} /> Live room</button>
            </header>
            <div className="launch-show__cast">
              {show.cast.map((entry) => {
                const isCouple = Boolean(entry.relationshipId || entry.memberIds.length > 1)
                return (
                  <button
                    type="button"
                    key={entry.label}
                    onClick={() => onOpenEntity({
                      id: entry.relationshipId ?? entry.memberIds[0],
                      type: isCouple ? 'relationship' : 'person',
                      label: entry.label,
                      detail: `${show.title} · Season ${show.season}${entry.returning ? ' · Returning' : ' · New'}`,
                      initials: initials(entry.label),
                      seasonCount: 1,
                    })}
                  >
                    <span className="launch-show__avatar">{isCouple ? <Heart size={14} /> : <UserRound size={14} />}<b>{initials(entry.label)}</b></span>
                    <span><strong>{entry.label}</strong><small>{entry.returning ? 'Returning' : 'New this season'}</small></span>
                    <ChevronRight size={15} />
                  </button>
                )
              })}
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
